import { IUserGroupPermission } from 'api/api';

import { constants } from './constants';
import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory("userPermissions");
export const GetUserGroupPermissions = actionCreator.async<{}, IUserGroupPermission[]>(constants.GET_USER_PERMISSION);
